import { Question } from './Question'

export class Answer {
    constructor(
        public question: Question,
        public answer: string
    ) { }
}

export function answerForQuestion(
    question: Question,
    value: unknown
): Answer | null {
    if (question.isTickable) {
        return new Answer(question, value ? 'true' : 'false')
    }
    if (value === null || value === undefined) {
        return null
    }
    return new Answer(question, String(value))
}
